module.exports = "/fonts/gt-walsheim-ultra-light.ttf";